module.exports = __webpack_public_path__ + "img/t5-purple.87a6e720.png";